import { RolPlataforma } from '../../../../core/models/novedades.models';
import { Postulacion } from '../../../../core/models/postulaciones.models';
import { etiquetaPatrocinio } from '../../../../core/utils/postulaciones-filter.util';

export type ModoAccesoPostulacion = 'observar' | 'solo_lectura' | 'editar' | 'acceder';

export function puedeEliminarPostulacion(rol: RolPlataforma, item: Postulacion): boolean {
  return rol === 'postulante' && item.estadoPostulacion === 'en_preparacion';
}

export function estadoPermiteEdicionPostulacion(estado: Postulacion['estadoPostulacion']): boolean {
  return estado === 'en_preparacion' || estado === 'observada';
}

export function puedeEditarPostulacionComoAyudante(rol: RolPlataforma, item: Postulacion): boolean {
  if (rol !== 'ayudante_postulante') return false;
  if (item.ayudanteActivo === false) return false;
  if (typeof item.puedeEditar === 'boolean') return item.puedeEditar;
  return item.editablePorAyudante && estadoPermiteEdicionPostulacion(item.estadoPostulacion) && !item.bloqueadaPorRechazoPatrocinio;
}

export function mostrarSoloVisualizacionInstitucional(rol: RolPlataforma, item: Postulacion): boolean {
  return esRolInstitucional(rol) && item.estadoInvitacion !== 'aceptada';
}

export function resolverModoAccesoPorRol(rol: RolPlataforma, item: Postulacion): ModoAccesoPostulacion {
  if (esRolInstitucional(rol)) return 'observar';
  if (item.bloqueadaPorRechazoPatrocinio) return 'solo_lectura';
  if (rol === 'postulante' && estadoPermiteEdicionPostulacion(item.estadoPostulacion)) return 'editar';
  if (rol === 'ayudante_postulante' && !estadoPermiteEdicionPostulacion(item.estadoPostulacion)) return 'solo_lectura';
  if (puedeEditarPostulacionComoAyudante(rol, item)) return 'editar';
  return 'acceder';
}

export function obtenerDetalleEstadoRepresentante(rol: RolPlataforma, item: Postulacion): string {
  if (rol !== 'representante_institucional') return '';

  const invitacion =
    item.estadoInvitacion === 'aceptada'
      ? 'Invitaci\u00f3n aceptada'
      : item.estadoInvitacion === 'observada'
        ? 'Invitaci\u00f3n observada'
        : 'Invitaci\u00f3n rechazada';
  const patrocinio = etiquetaPatrocinio(item.estadoPatrocinio);

  return patrocinio ? `${invitacion} - ${patrocinio}` : invitacion;
}

function esRolInstitucional(rol: RolPlataforma): boolean {
  return rol === 'representante_institucional' || rol === 'ayudante_representante';
}
